module.exports = __webpack_public_path__ + "static/img/8.f7ddd05.png";


//////////////////
// WEBPACK FOOTER
// ./static/ALL/8.png
// module id = XAhj
// module chunks = 202